<div class="panel panel-default">
    <app-rt-records
        [hasGrid]="true"
        [hasTemperature]="true"
        [device]="device"
        [companyName]="companyName"
        [siteName]="siteName"
    ></app-rt-records>
</div>